<template>
  <div>
    <!-- ========================================================================================================================================= -->

    <!-- Tandas Section -->
    <panel title="Tandas" noButton="true">
      <div class="flex flex-col justify-between">
        <div class="flex flex-col justify-start">
          <div class="w-full max-w-screen-2xl m-auto">
            <div class="bg-white">
              <div class="grid grid-cols-12 gap-4 mt-4">
                <div class="col-span-12 bg-white p-6">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-1">
                    <div class="border p-6">
                      <div class="mb-2 text-lg font-semibold text-gray-600">
                        Jumlah Keseluruhan Tandas
                      </div>
                      <div class="flex items-end">
                        <span class="text-4xl font-bold text-gray-700"
                          >750</span
                        >
                      </div>
                    </div>

                    <!-- <div class="widget widget-stats bg-gradient-purple">
                  <div class="stats-icon stats-icon-lg">
                    <i class="fas fa-lightbulb"></i>
                  </div>
                  <div class="stats-content">
                    <div class="stats-title">
                      Jumlah Keseluruhan Tandas
                    </div>
                    <div class="text-4xl font-bold text-gray-700stats-number">
                      750
                    </div> -->
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="bg-white p-6 mt-1">
                <div class="col-span-12">
                  <div class="flex flex-col md:flex-row justify-between">
                    <div>
                      <h4 class="text-gray-900 font-semibold text-2xl pl-2">
                        Pengauditan dan Penarafan Bintang Tandas Awam di PBT
                      </h4>
                    </div>
                    <div class="flex items-center justify-end mt-4 md:mt-0">
                      <select
                        class="w-full md:w-auto py-2 px-3 border rounded bg-white text-sm"
                        fdprocessedid="s3g17"
                      >
                        <option>Semua</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-3 grid-rows-2 gap-4 mt-4">
                  <div
                    class="row-span-2 col-span-3 md:col-span-1 flex flex-col items-center justify-center border py-6"
                  >
                    <h3
                      class="text-sm text-gray-500 mb-1 flex items-center justify-between"
                    >
                      <div class="flex items-center">
                        <span class="px-4 mr-2 font-semibold text-lg"
                          >Jumlah Tandas Yang Diaudit</span
                        >
                      </div>
                    </h3>
                    <div class="text-4xl font-bold">750</div>
                  </div>
                  <div
                    class="bg-white border px-2 py-4 md:col-span-1 col-span-3"
                  >
                    <h3
                      class="text-sm text-gray-500 mb-1 flex items-center justify-between"
                    >
                      <div class="flex items-center">
                        <span class="px-4 mr-2 font-semibold text-lg">
                          5 Bintang
                        </span>
                      </div>
                    </h3>
                    <h2 class="text-xl font-bold pt-3">
                      <div class="grid grid-cols-3">
                        <div class="flex items-center justify-center flex-col">
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div class="text-center">
                          <h5 class="text-gray-400 text-sm font-normal mb-2">
                            Jumlah
                          </h5>
                          265
                        </div>
                      </div>
                    </h2>
                  </div>
                  <div
                    class="bg-white border px-2 py-4 md:col-span-1 col-span-3"
                  >
                    <h3
                      class="text-sm text-gray-500 mb-1 flex items-center justify-between"
                    >
                      <div class="flex items-center">
                        <span class="px-4 mr-2 font-semibold text-lg">
                          4 Bintang
                        </span>
                      </div>
                    </h3>
                    <h2 class="text-xl font-bold pt-3">
                      <div class="grid grid-cols-3">
                        <div class="flex items-center justify-center flex-col">
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div class="text-center">
                          <h5 class="text-gray-400 text-sm font-normal mb-2">
                            Jumlah
                          </h5>
                          221
                        </div>
                      </div>
                    </h2>
                  </div>
                  <div
                    class="bg-white border px-2 py-4 md:col-span-1 col-span-3"
                  >
                    <h3
                      class="text-sm text-gray-500 mb-1 flex items-center justify-between"
                    >
                      <div class="flex items-center">
                        <span class="px-4 mr-2 font-semibold text-lg">
                          3 Bintang
                        </span>
                      </div>
                    </h3>
                    <h2 class="text-xl font-bold pt-3">
                      <div class="grid grid-cols-3">
                        <div class="flex items-center justify-center flex-col">
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div class="text-center">
                          <h5 class="text-gray-400 text-sm font-normal mb-2">
                            Jumlah
                          </h5>
                          171
                        </div>
                      </div>
                    </h2>
                  </div>
                  <div
                    class="bg-white border px-2 py-4 md:col-span-1 col-span-3"
                  >
                    <h3
                      class="text-sm text-gray-500 mb-1 flex items-center justify-between"
                    >
                      <div class="flex items-center">
                        <span class="px-4 mr-2 font-semibold text-lg"
                          >2 Bintang dan Kebawah</span
                        >
                      </div>
                    </h3>
                    <h2 class="text-xl font-bold pt-3">
                      <div class="grid grid-cols-3">
                        <div class="flex items-center justify-center flex-col">
                          <div class="flex items-center justify-center">
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                            <svg
                              class="text-yellow-400 w-4 h-4"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div class="text-center">
                          <h5 class="text-gray-400 text-sm font-normal mb-2">
                            Jumlah
                          </h5>
                          93
                        </div>
                      </div>
                    </h2>
                  </div>
                </div>
              </div>
              <div
                class="vfm vfm--inset vfm--fixed"
                data-v-2836fdb5=""
                style="z-index: 1000; display: none"
              >
                <div
                  class="vfm__container vfm--absolute vfm--inset vfm--outline-none flex justify-center items-center"
                  aria-expanded="false"
                  role="dialog"
                  aria-modal="true"
                  tabindex="-1"
                  data-v-2836fdb5=""
                  style="display: none"
                >
                  <div
                    class="vfm__content relative flex flex-col max-h-full max-w-4xl mx-4 p-4 mt-4 mb-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900"
                    data-v-2836fdb5=""
                  >
                    <span class="text-2xl font-bold" data-v-2836fdb5-s=""
                      >Upload file</span
                    >
                    <div class="flex-grow overflow-y-auto" data-v-2836fdb5-s="">
                      <form class="mt-2" data-v-2836fdb5-s="">
                        <div data-v-2836fdb5-s="">
                          <label
                            for="fileName"
                            class="text-gray-600"
                            data-v-2836fdb5-s=""
                            >Jenis data</label
                          >
                        </div>
                        <div class="flex" data-v-2836fdb5-s="">
                          <select
                            name="jenis_data"
                            class="bg-gray-100 py-1 px-1 rounded-l-md"
                            id=""
                            data-v-2836fdb5-s=""
                          >
                            <option value="overall" data-v-2836fdb5-s="">
                              Data ringkasan tahunan
                            </option>
                            <option value="details" data-v-2836fdb5-s="">
                              Data terperinci Negeri dan PBT
                            </option>
                          </select>
                        </div>
                        <div class="mt-3" data-v-2836fdb5-s="">
                          <label
                            for="fileName"
                            class="text-gray-600"
                            data-v-2836fdb5-s=""
                            >Data file</label
                          >
                        </div>
                        <div class="flex" data-v-2836fdb5-s="">
                          <input
                            id="fileName"
                            type="file"
                            class="bg-gray-100 py-1 px-1 rounded-l-md"
                            data-v-2836fdb5-s=""
                          /><button
                            class="rounded-r-md bg-gray-500 px-3 text-sm text-white"
                            data-v-2836fdb5-s=""
                          >
                            <span data-v-2836fdb5-s="">Upload</span>
                          </button>
                        </div>
                      </form>
                    </div>
                    <div
                      class="flex-shrink-0 flex justify-between items-center pt-4"
                      data-v-2836fdb5-s=""
                    >
                      <button
                        class="bg-gray-100 px-2 py-1 rounded text-gray-700"
                        data-v-2836fdb5-s=""
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </panel>

    <!-- ===============================================================================================================-->

    <!-- Section Perangkap Lemak, Minyak, Gris (FOGT) -->
    <panel title="Perangkap Lemak, Minyak, Gris (FOGT)" noButton="true">
      <div class="row">
        <!-- Bilangan Premis Makanan Section-->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-blue m-b-10">
            <div class="stats-content">
              <div class="stats-title">Bilangan Premis Makanan</div>
              <div class="grid grid-cols-1 md:grid-cols-2 py-2">
                <div class="text-center py-4">
                  <div class="text-2xl">PBT</div>
                  <div class="text-4xl font-bold mt-4">5,217</div>
                </div>
                <div class="md:border-l md:border-blue-300 text-center py-4">
                  <div class="text-2xl">Swasta</div>
                  <div class="text-4xl font-bold mt-4">21,833</div>
                </div>
              </div>
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>

        <!-- Bilangan Perangkap Minyak Section -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-pink m-b-10">
            <div class="stats-content">
              <div class="stats-title">Bilangan Perangkap Minyak</div>
              <div class="grid grid-cols-2 py-1">
                <div class="grid grid-cols-2 col-span-2 md:col-span-1">
                  <div
                    class="text-center font-semibold text-gray-500 mb-1 col-span-2"
                  >
                    <span class="text-xl px-1 py-1 text-white">
                      Jenis Individu
                    </span>
                  </div>
                  <div class="text-center py-4">
                    <div class="text-xl font-medium">PBT</div>
                    <div class="text-xl font-semibold mt-3">3,267</div>
                  </div>
                  <div class="border-l text-center py-4">
                    <div class="text-xl font-medium">Swasta</div>
                    <div class="text-xl font-semibold mt-3">17,228</div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-2 mt-6 md:mt-0 md:border-l col-span-2 md:col-span-1"
                >
                  <div
                    class="text-center font-semibold text-gray-500 mb-3 col-span-2"
                  >
                    <span class="text-xl px-1 py-1 text-white">
                      Jenis Komunal
                    </span>
                  </div>
                  <div class="text-center py-4">
                    <div class="text-xl font-medium">PBT</div>
                    <div class="text-xl font-semibold mt-3">347</div>
                  </div>
                  <div class="border-l text-center py-4">
                    <div class="text-xl font-medium">Swasta</div>
                    <div class="text-xl font-semibold mt-3">0</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </panel>

    <!-- ===============================================================================================================-->

    <!-- Increased gap between columns -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Kolam Renang Section -->
      <div class="flex flex-col justify-between h-full mb-8">
        <!-- Added bottom margin -->
        <div class="flex flex-col justify-start">
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div
              class="col-span-12 bg-white p-6"
              style="
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              "
            >
              <!-- Custom border-radius and shadow -->
              <div class="col-span-12">
                <div class="flex flex-col md:flex-row justify-between">
                  <div>
                    <h4 class="text-gray-900 font-semibold text-2xl pl-2 mb-2">
                      Kolam Renang
                    </h4>
                  </div>
                </div>
              </div>
              <div class="widget widget-stats bg-gradient-blue">
                <div class="stats-icon stats-icon-lg">
                  <i class="fas fa-mountain"></i>
                </div>
                <div class="stats-content">
                  <div class="stats-title">Bilangan Premis Kolam Renang</div>
                  <div class="stats-number">402</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION LAMPU JALAN -->
      <div class="flex flex-col justify-between h-full mb-8">
        <div class="flex flex-col justify-start">
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div
              class="col-span-12 bg-white p-6"
              style="
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              "
            >
              <!-- Custom border-radius and shadow -->
              <div class="col-span-12">
                <div class="flex flex-col md:flex-row justify-between">
                  <div>
                    <h4 class="text-gray-900 font-semibold text-2xl pl-2 mb-2">
                      Lampu Jalan
                    </h4>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="widget widget-stats bg-gradient-purple">
                  <div class="stats-icon stats-icon-lg">
                    <i class="fas fa-lightbulb"></i>
                  </div>
                  <div class="stats-content">
                    <div class="stats-title">
                      Bilangan lampu jalan jenis SON
                    </div>
                    <div class="stats-number">36,983</div>
                  </div>
                </div>

                <div class="widget widget-stats bg-gradient-purple">
                  <div class="stats-icon stats-icon-lg">
                    <i class="fas fa-lightbulb"></i>
                  </div>
                  <div class="stats-content">
                    <div class="stats-title">
                      Bilangan lampu jalan jenis LED
                    </div>
                    <div class="stats-number">87,996</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- =================================================================================================================== -->

    <panel title="Penyalahgunaan Parkir OKU" noButton="true">
      <div class="row">
        <!-- PARKIR OKU -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-gradient-orange m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-user fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Bil. Kes Penyalahgunaan Parkir OKU</div>
              <div class="stats-number">133</div>
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>

        <!-- KOMPAUN SECTION -->
        <div class="col-md-auto col-10 flex-grow-1">
          <div class="widget widget-stats bg-pink m-b-10">
            <div class="stats-icon stats-icon-lg">
              <i class="fa fa-dollar-sign fa-fw"></i>
            </div>
            <div class="stats-content">
              <div class="stats-title">Amaun Kompaun</div>
              <div class="stats-number">RM10,128.00</div>
              <div class="stats-desc"></div>
            </div>
          </div>
        </div>
      </div>
    </panel>

    <!-- ========================================================================================================== -->

    <!-- Increased gap between columns -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- SPAH Section -->
      <div class="flex flex-col justify-between h-full mb-8">
        <!-- Added bottom margin -->
        <div class="flex flex-col justify-start">
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div
              class="col-span-12 bg-white p-6"
              style="
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              "
            >
              <!-- Custom border-radius and shadow -->
              <div class="col-span-12">
                <div class="flex flex-col md:flex-row justify-between">
                  <div>
                    <h4 class="text-gray-900 font-semibold text-2xl pl-2 mb-2">
                      <span class="flex items-center">
                        SPAH
                        <a
                          href="#"
                          title="Sistem Pengumpulan dan Penggunaan Semula Air Hujan"
                          class="ml-2"
                        >
                          <svg
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </a>
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="widget widget-stats bg-gradient-teal">
                <div class="stats-icon stats-icon-lg">
                  <i class="fa fa-list-ol fa-fw"></i>
                </div>
                <div class="stats-content">
                  <div class="stats-title">Bilangan Keseluruhan Bangunan</div>
                  <div class="stats-number">403</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cerun Section -->
      <div class="flex flex-col justify-between h-full mb-8">
        <!-- Added bottom margin -->
        <div class="flex flex-col justify-start">
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div
              class="col-span-12 bg-white p-6"
              style="
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              "
            >
              <!-- Custom border-radius and shadow -->
              <div class="col-span-12">
                <div class="flex flex-col md:flex-row justify-between">
                  <div>
                    <h4 class="text-gray-900 font-semibold text-2xl pl-2 mb-2">
                      Cerun
                    </h4>
                  </div>
                </div>
              </div>
              <div class="widget widget-stats bg-gradient-blue">
                <div class="stats-icon stats-icon-lg">
                  <i class="fas fa-mountain"></i>
                </div>
                <div class="stats-content">
                  <div class="stats-title">Jumlah Cerun</div>
                  <div class="stats-number">5089</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION JALAN -->
      <div class="flex flex-col justify-between h-full mb-8">
        <div class="flex flex-col justify-start">
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div
              class="col-span-12 bg-white p-6"
              style="
                border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              "
            >
              <!-- Custom border-radius and shadow -->
              <div class="col-span-12">
                <div class="flex flex-col md:flex-row justify-between">
                  <div>
                    <h4 class="text-gray-900 font-semibold text-2xl pl-2 mb-2">
                      Jalan
                    </h4>
                  </div>
                </div>
              </div>
              <div class="widget widget-stats bg-gradient-purple">
                <div class="stats-icon stats-icon-lg">
                  <i class="fa fa-road"></i>
                </div>
                <div class="stats-content">
                  <div class="stats-title">Panjang Jalan di PBT</div>
                  <div class="stats-number">79,511,577.00 KM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ======================================================================================================================= -->

    <!-- Section for Senarai PBT -->

    <panel title="Senarai 52 PBT Melaksanakan Sistem ePBT 2.0" noButton="true">
      <div class="col-span-12 grid grid-cols-1 bg-white mt-1">
        <div class="bg-white px-1 py-1">
          <!-- KEDAH -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('kedah')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.kedah"
              aria-controls="collapseKedah"
            >
              <span class="font-bold text-xs">Kedah ( 9 PBT )</span>
              <svg
                :class="{
                  'rotate-180': isExpanded.kedah,
                  'rotate-0': !isExpanded.kedah,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="20"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapseKedah" v-show="isExpanded.kedah">
              <!-- <ul class="list-disc ml-8" style="list-style: disc"> -->
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Bandaraya Alor Setar</li>
                <li>Majlis Perbandaran Langkawi</li>
                <li>Majlis Daerah Baling</li>
                <li>Majlis Daerah Bandar Baharu</li>
                <li>Majlis Daerah Kubang Pasu</li>
                <li>Majlis Daerah Padang Terap</li>
                <li>Majlis Daerah Pendang</li>
                <li>Majlis Daerah Sik</li>
                <li>Majlis Daerah Yan</li>
              </ul>
            </div>
          </div>

          <!-- KELANTAN -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('kelantan')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.kelantan"
              aria-controls="collapseKelantan"
            >
              <span class="font-bold text-xs">Kelantan ( 12 PBT )</span>
              <svg
                :class="{
                  'rotate-180': isExpanded.kelantan,
                  'rotate-0': !isExpanded.kelantan,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapseKelantan" v-show="isExpanded.kelantan">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Perbandaran Kota Bharu</li>
                <li>Majlis Daerah Ketereh</li>
                <li>Majlis Daerah Tanah Merah</li>
                <li>Majlis Daerah Bachok</li>
                <li>Majlis Daerah Gua Musang</li>
                <li>Majlis Daerah Jeli</li>
                <li>Majlis Daerah Dabong</li>
                <li>Majlis Daerah Kuala Krai</li>
                <li>Majlis Daerah Machang</li>
                <li>Majlis Daerah Pasir Mas</li>
                <li>Majlis Daerah Pasir Puteh</li>
                <li>Majlis Daerah Tumpat</li>
              </ul>
            </div>
          </div>

          <!-- MELAKA -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('melaka')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.melaka"
              aria-controls="collapseMelaka"
            >
              <span class="font-bold text-xs">Melaka ( 1 PBT )</span>
              <svg
                :class="{
                  'rotate-180': isExpanded.melaka,
                  'rotate-0': !isExpanded.melaka,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapseMelaka" v-show="isExpanded.melaka">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Perbandaran Jasin</li>
              </ul>
            </div>
          </div>

          <!-- NEGERI SEMBILAN -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('negeriSembilan')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.negeriSembilan"
              aria-controls="collapseNegeriSembilan"
            >
              <span class="font-bold text-xs">Negeri Sembilan ( 5 PBT )</span
              ><svg
                :class="{
                  'rotate-180': isExpanded.negeriSembilan,
                  'rotate-0': !isExpanded.negeriSembilan,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapseNegeriSembilan" v-show="isExpanded.negeriSembilan">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Daerah Jelebu</li>
                <li>Majlis Daerah Jempol</li>
                <li>Majlis Daerah Kuala Pilah</li>
                <li>Majlis Daerah Rembau</li>
                <li>Majlis Daerah Tampin</li>
              </ul>
            </div>
          </div>

          <!-- PAHANG -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('pahang')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.pahang"
              aria-controls="collapsePahang"
            >
              <span class="font-bold text-xs">Pahang ( 6 PBT )</span
              ><svg
                :class="{
                  'rotate-180': isExpanded.pahang,
                  'rotate-0': !isExpanded.pahang,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapsePahang" v-show="isExpanded.pahang">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Daerah Bera</li>
                <li>Majlis Daerah Jerantut</li>
                <li>Majlis Daerah Lipis</li>
                <li>Majlis Daerah Maran</li>
                <li>Majlis Daerah Raub</li>
                <li>Majlis Daerah Rompin</li>
              </ul>
            </div>
          </div>

          <!-- PERAK -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('perak')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.perak"
              aria-controls="collapsePerak"
            >
              <span class="font-bold text-xs">Perak ( 13 PBT )</span
              ><svg
                :class="{
                  'rotate-180': isExpanded.perak,
                  'rotate-0': !isExpanded.perak,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapsePerak" v-show="isExpanded.perak">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Perbandaran Manjung</li>
                <li>Majlis Perbandaran Kuala Kangsar</li>
                <li>Majlis Perbandaran Teluk Intan</li>
                <li>Majlis Daerah Gerik</li>
                <li>Majlis Daerah Kerian</li>
                <li>Majlis Daerah Batu Gajah</li>
                <li>Majlis Daerah Kampar</li>
                <li>Majlis Daerah Lenggong</li>
                <li>Majlis Daerah Pengkalan Hulu</li>
                <li>Majlis Daerah Perak Tengah</li>
                <li>Majlis Daerah Selama</li>
                <li>Majlis Daerah Tanjong Malim</li>
                <li>Majlis Daerah Tapah</li>
              </ul>
            </div>
          </div>

          <!-- PERLIS -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('perlis')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.perlis"
              aria-controls="collapsePerlis"
            >
              <span class="font-bold text-xs">Perlis ( 1 PBT )</span
              ><svg
                :class="{
                  'rotate-180': isExpanded.perlis,
                  'rotate-0': !isExpanded.perlis,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapsePerlis" v-show="isExpanded.perlis">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Perbandaran Kangar</li>
              </ul>
            </div>
          </div>

          <!-- TERENGGANU -->
          <div class="mb-3">
            <button
              @click="toggleDropdown('terengganu')"
              class="flex items-center space-x-3"
              :aria-expanded="isExpanded.terengganu"
              aria-controls="collapseTerengganu"
            >
              <span class="font-bold text-xs">Terengganu ( 5 PBT )</span
              ><svg
                :class="{
                  'rotate-180': isExpanded.terengganu,
                  'rotate-0': !isExpanded.terengganu,
                }"
                class="w-3 transition-all duration-200 transform ml-2"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 10"
                aria-hidden="true"
              >
                <path
                  d="M15 1.2l-7 7-7-7"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div id="collapseTerengganu" v-show="isExpanded.terengganu">
              <ul class="list-disc" style="margin-left: 20px">
                <li>Majlis Bandaraya Kuala Terengganu</li>
                <li>Majlis Daerah Besut</li>
                <li>Majlis Daerah Setiu</li>
                <li>Majlis Daerah Marang</li>
                <li>Majlis Daerah Hulu Terengganu</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </panel>

    <!-- ====================================================================================================================================== -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpanded: {
        kedah: false,
        kelantan: false,
        melaka: false,
        negeriSembilan: false,
        pahang: false,
        perak: false,
        perlis: false,
        terengganu: false,
        // Add other states here as needed
      },
    };
  },
  methods: {
    toggleDropdown(state) {
      this.isExpanded[state] = !this.isExpanded[state];
    },
  },
};
</script>

<style scoped>
.rotate-0 {
  transform: rotate(0deg);
}
.rotate-180 {
  transform: rotate(180deg);
}
</style>

<!-- <section title="" noButton="true" class="">
  <section class="">
    <div class="flex w-full">
      <div class="w-full text-center">Negeri 1 select</div>
      <div class="w-full text-center">Negeri 2 select</div>
    </div>

    SECTION SPAH
    <div class="flex w-full">
      <div class="w-full">
        <h2 class="text-3xl font-semibold">SPAH</h2>
        <a href="#" title="Sistem Pengumpulan dan Penggunaan Semula Air Hujan" class="ml-2">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
          </svg>
        </a>
        <div class="widget widget-stats bg-gradient-teal">
          <div class="stats-icon stats-icon-lg">
            <i class="fa fa-list-ol fa-fw"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">Bilangan Keseluruhan Bangunan</div>
            <div class="stats-number">403</div>
          </div>
        </div>
      </div>

      SECTION CERUN
      <div class="w-full">
        <div class="col-xl-10 col-md-6"></div>
        <h2 class="text-3xl font-semibold">Cerun</h2>
        <div class="widget widget-stats bg-gradient-blue">
          <div class="stats-icon">
            <i class="fas fa-mountain"></i>
          </div>
          <div class="stats-content">
            <div class="stats-title">Jumlah Cerun</div>
            <div class="stats-number">5089</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section> -->
